import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type CreateGroupHybridKekApiResponse } from '../../services/hybrid/createHybridKek'

export interface CreateHybridKekState {
  isLoading: boolean
  error: string | undefined
  data: CreateGroupHybridKekApiResponse | undefined
  httpStatus: number | undefined
}

const initialState: CreateHybridKekState = {
  isLoading: false,
  error: undefined,
  data: undefined,
  httpStatus: 0
}

const createHybridKekSlice = createSlice({
  name: 'createHybridKekSlice',
  initialState,
  reducers: {
    createHybridKekLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        data: undefined,
        httpStatus: 0
      }
    },
    createHybridKekUpdateAction: (state, action: PayloadAction<{ data: CreateGroupHybridKekApiResponse, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    createHybridKekErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        data: undefined,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  createHybridKekLoadingAction,
  createHybridKekUpdateAction,
  createHybridKekErrorAction
} = createHybridKekSlice.actions

export default createHybridKekSlice.reducer
